import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { useCan } from '@/lib/permissions';
import { cn } from '@/lib/utils';

/**
 * The Employees & HR sub-navigation (PART 12): Employee List (HR-01), Job
 * Roles (R11's management UI — [decided at build time] as its own tab),
 * Attendance (HR-03), Leave (HR-04), Payroll (HR-02), Recruitment (HR-05).
 *
 * Payroll is offered only to payroll.view holders (R15 — the Owner alone on
 * day one): the tab is UX, the server is the fence.
 */
export function HrTabs() {
  const { t } = useTranslation();
  const canPayroll = useCan('payroll.view');

  const tabs = [
    { to: '/employees', end: true, key: 'hr.tabEmployees' },
    { to: '/employees/roles', end: false, key: 'hr.tabJobRoles' },
    { to: '/employees/attendance', end: false, key: 'hr.tabAttendance' },
    { to: '/employees/leave', end: false, key: 'hr.tabLeave' },
    ...(canPayroll ? [{ to: '/employees/payroll', end: false, key: 'hr.tabPayroll' }] : []),
    { to: '/employees/recruitment', end: false, key: 'hr.tabRecruitment' },
  ];

  return (
    <nav className="flex flex-wrap gap-1 border-b border-border pb-px">
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            cn(
              'rounded-t-md px-3 py-2 text-sm text-muted-foreground transition-colors hover:text-foreground',
              isActive && 'border-b-2 border-primary font-medium text-foreground',
            )
          }
        >
          {t(tab.key)}
        </NavLink>
      ))}
    </nav>
  );
}
